import React from 'react';
// import { QRCode } from 'react-qrcode-logo';
import QRCode from 'react-qr-code';

function QRCodeGenerator({ qrString, size = 250 }) {
  if (!qrString) return null;

  return (
    <QRCode
      size={size}
      style={{
        height: 'auto',
        margin: '0px'
      }}
      value={qrString}
      viewBox="0 0 256 256"
    />

    // <QRCode
    //   value={qrString}
    //   size={size}
    //   logoWidth={40}
    //   qrStyle="squares"
    //   // renderAs="canvas"
    //   fgColor="#000000" // Pure black for crisp contrast
    //   bgColor="#ffffff" // White background
    //   // ecLevel="H" // High error correction (30% recovery)
    //   quietZone={2} // Minimal white border
    //   removeQrCodeBehindLogo
    // />
  );
}

export default QRCodeGenerator;
